import { render } from "./FAQAdminCategory.vue?vue&type=template&id=2b6d4a54&scoped=true"
import script from "./FAQAdminCategory.vue?vue&type=script&lang=js"
export * from "./FAQAdminCategory.vue?vue&type=script&lang=js"

import "./FAQAdminCategory.vue?vue&type=style&index=0&id=2b6d4a54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b6d4a54"

export default script